export default {
  data() {
    return {};
  },
  created() {
    this.login();
  },
  methods: {
    // 登录园区平台
    async login() {
      let data = this.$store.dispatch('login');
      // let params = {
      //   username: "18642010001",
      //   password: "123456",
      // };
      // console.log('存进来token开始');
      // let {code,token} = await this.$api.login(params);
      // console.log('存进来token结束');
      // if(code == '200'){
      //   window.localStorage.setItem("token", token);
      // }
    }
  }
};